<template>
  <div class="select-range">
    <el-select
      v-if="requestData"
      class="sr-select"
      v-model="request"
      placeholder="服务请求类型"
      size="mini"
      :clearable="true"
      filterable
      @change="changeRequest"
    >
      <el-option v-for="item in requestData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>

    <el-select
      v-if="brandData"
      class="sr-select"
      v-model="brand"
      placeholder="选择品牌"
      size="mini"
      :clearable="true"
      filterable
      @change="changeBrand"
    >
      <el-option v-for="item in brandData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>

    <el-select
      v-if="engData"
      class="sr-select"
      v-model="engger"
      placeholder="选择工程师"
      size="mini"
      :clearable="true"
      filterable
      @change="changeEng"
    >
      <el-option v-for="item in engData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
    <el-select
      v-if="serData"
      class="sr-select"
      v-model="service"
      placeholder="选择服务商"
      size="mini"
      :clearable="true"
      filterable
      @change="changeSer"
    >
      <el-option v-for="item in serData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>

    <template v-if="showTime">
      <!-- <el-select class="sr-dateType" v-model="dateConf.type" placeholder="" size="mini">
      <el-option v-for="item in dateConf.options" :key="item.label" :label="item.label" :value="item.val" />
    </el-select> -->
      <el-date-picker
        v-model="date"
        :type="dateConf.type"
        value-format="yyyy-MM-dd"
        range-separator="-"
        placeholder="请选择"
        class="sr-date"
        size="mini"
        @change="changeDate"
      ></el-date-picker>
    </template>
  </div>
</template>

<script>
/**
 * @typedef IRange Chart 图过滤数据
 * @property {string} source 唯一标识符
 * @property {'brand'|'engger'|'sercice'|'request'|'date'} type 哪种过滤条件
 * - brand 品牌
 * - engger 工程师
 * - service 服务商
 * - request 服务请求类型
 * - date 日期
 * @property {object} data 携带数据
 * @property {*} data.current 修改后的数据
 * - select: string
 * - date: string[]
 * @property {*} data.row 较完整信息
 * - select: {label: string, value: string}
 */

/**
 * 数据选择范围
 */
export default {
  name: 'SelectRange',
  props: {
    source: { type: String, default: '' },
    /**
     * 品牌列表展示数据
     * - 默认不显示品牌列表
     */
    brandData: { type: Array },
    engData: { type: Array },
    serData: { type: Array },
    requestData: { type: Array },
    showTime: { type: Boolean, default: true }
  },
  data() {
    return {
      /** 品牌选择数据 */
      brand: '',
      /** 工程师选择数据 */
      engger: '',
      /** 服务商选择数据 */
      service: '',
      /** 服务请求类型 */
      request: '',
      /** 日期选择数据 */
      date: '',
      dateConf: {
        type: 'daterange',
        options: [
          { label: '年', val: 'year' },
          { label: '月', val: 'month' },
          // { label: '周', val: 'week' },
          { label: '日', val: 'daterange' }
        ]
      }
    }
  },
  methods: {
    setValue: function(field, value) {
      this[field] = value
    },

    /**
     * 自定义修改事件
     * @param data 携带数据
     * @param type 触发方式
     */
    emitChange: function(data, type) {
      this.$emit(
        'range-change',
        /** @type {IRange} */
        { source: this.source, type, data: data }
      )
    },
    changeBrand: function(val) {
      let row = this.brandData.filter(item => item.value === val)[0]

      this.emitChange({ current: val, row: row }, 'brand')
    },
    changeEng: function(val) {
      let row = this.engData.filter(item => item.value === val)[0]

      this.emitChange({ current: val, row: row }, 'engger')
    },
    changeSer: function(val) {
      let row = this.serData.filter(item => item.value === val)[0]

      this.emitChange({ current: val, row: row }, 'service')
    },
    changeRequest: function(val) {
      let row = this.requestData.filter(item => item.value === val)[0]

      this.emitChange({ current: val, row: row }, 'request')
    },
    changeDate: function(val) {
      this.emitChange({ current: val || [] }, 'date')
    },
    handleChange: function() {
      // this.$emit('range-change', { source: this.source, data: {} })
      this.emitChange({}, 'click')
    }
  }
}
</script>

<style lang="postcss">
.select-range {
  display: flex;
  position: absolute;
  top: 20px;
  right: 30px;
  /* padding: 5px 20px; */
  /* background: coral; */
  color: #fff;
  cursor: pointer;
  z-index: 10;

  & > div:not(:last-child) {
    margin-right: 5px;
  }

  & .sr-select {
    width: 160px;
  }

  & .sr-dateType {
    width: 80px;
  }

  & .sr-date {
    width: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/SelectRange.vue